import { useCallback } from "react";
import { ConjugationListenCounts } from "../utils/conjugationListenCountsStorage";
import { useDeviceProgress } from "./useDeviceProgress";

export function useConjugationListenCounts() {
    const { data: counts, update, syncStatus } = useDeviceProgress<ConjugationListenCounts>("conjugationListenCounts", true);
    const increment = useCallback((key: string) => { void update({ kind: "increment", key }); }, [update]);
    return { counts, increment, syncStatus };
}
